import React, { useState, useEffect } from "react";
import { serverFetch } from "@extensions";
import { useUser } from "@redux";
import { Checkbox, DatePicker, Button, message, Spin, Card, Space } from "antd";
import dayjs from "dayjs";
import "./sales.css";

const SalesUsed = () => {
  const user = useUser();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDeleted, setShowDeleted] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  useEffect(() => {
    if (user) {
      fetchSales();
    }
  }, [user, showDeleted, dateFrom, dateTo]);

  const fetchSales = async () => {
    if (!user) return;

    setLoading(true);
    try {
      const queryParams = {
        showDeleted: showDeleted,
        showPaid: true, // Оплаченные
      };

      if (dateFrom) {
        queryParams.from = dateFrom.format("YYYY-MM-DD");
      }
      if (dateTo) {
        queryParams.to = dateTo.format("YYYY-MM-DD");
      }

      const data = await serverFetch("OnlineClient/Sales", { method: "GET", queryParams: queryParams }, user);
      // Фильтруем только использованные (имеют флаг used или visitFinish)
      const usedSales = (data || []).filter(sale => sale.used || sale.visitFinish);
      setSales(usedSales);
    } catch (error) {
      console.error("Ошибка получения продаж:", error);
      message.error(error?.UserMessage || "Не удалось загрузить список покупок");
      setSales([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return dayjs(dateStr).format("DD.MM.YYYY");
  };

  const formatPrice = (price) => {
    if (!price) return "0";
    return price.toLocaleString("ru-RU");
  };

  return (
    <div className="sales-content">
      <div className="sales-filters">
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Space>
            <Checkbox checked={showDeleted} onChange={(e) => setShowDeleted(e.target.checked)}>
              Показать удаленные
            </Checkbox>
          </Space>
          <Space>
            <span>Период:</span>
            <DatePicker
              value={dateFrom}
              onChange={setDateFrom}
              format="DD.MM.YYYY"
              placeholder="От"
            />
            <DatePicker
              value={dateTo}
              onChange={setDateTo}
              format="DD.MM.YYYY"
              placeholder="До"
            />
            {(dateFrom || dateTo) && (
              <Button onClick={() => { setDateFrom(null); setDateTo(null); }} size="small">
                Сбросить
              </Button>
            )}
          </Space>
        </Space>
      </div>

      {loading ? (
        <div className="sales-loading">
          <Spin size="large" />
        </div>
      ) : (
        <div className="sales-list">
          {sales.length > 0 ? (
            sales.map((sale) => (
              <Card key={sale.id} className="sales-card" size="small">
                <div className="sales-card-content">
                  <div className="sales-card-header">
                    <div className="sales-card-date">{formatDate(sale.docDate)}</div>
                    {sale.deleted && <span className="sales-card-deleted">Удалено</span>}
                    {sale.status === 1 && <span className="sales-card-paid">Оплачено</span>}
                  </div>
                  <div className="sales-card-body">
                    <div className="sales-card-info">
                      <div className="sales-card-price">{formatPrice(sale.syma)} руб.</div>
                      {sale.productName && <div className="sales-card-product">{sale.productName}</div>}
                    </div>
                  </div>
                </div>
              </Card>
            ))
          ) : (
            <div className="sales-empty">Нет использованных покупок</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SalesUsed;

